import { getGroupChildren } from '../elements/groups'
import { GroupElement, TemplateElement } from '../templateEditor.types'

export type LayerRow = {
    element: TemplateElement
    depth: number
    topLevelIndex: number | null
    groupChildVisualIndex: number | null
    groupId: string | null
}

export type LayerPlacement =
    | { kind: 'top'; index: number }
    | { kind: 'child'; groupId: string; visual: number }
    | { kind: 'none' }

export const getLayerPlacement = (row: LayerRow): LayerPlacement => {
    if (row.topLevelIndex !== null) {
        return { kind: 'top', index: row.topLevelIndex }
    }
    if (row.groupId !== null && row.groupChildVisualIndex !== null) {
        return { kind: 'child', groupId: row.groupId, visual: row.groupChildVisualIndex }
    }
    return { kind: 'none' }
}

export const buildLayerRows = (elements: TemplateElement[], expandedGroupIds: Set<string>): LayerRow[] => {
    const topLevel = elements.filter((element) => !element.groupId).reverse()
    const rows: LayerRow[] = []

    topLevel.forEach((element, topLevelIndex) => {
        rows.push({
            element,
            depth: 0,
            topLevelIndex,
            groupChildVisualIndex: null,
            groupId: null,
        })

        if (element.type !== 'group' || !expandedGroupIds.has(element.id)) {
            return
        }

        const group = element as GroupElement
        const byId = new Map(getGroupChildren(elements, group.id).map((child) => [child.id, child]))
        const ordered = [...group.children]
            .map((id) => byId.get(id))
            .filter((child): child is TemplateElement => Boolean(child))
            .reverse()

        ordered.forEach((child, groupChildVisualIndex) => {
            rows.push({
                element: child,
                depth: 1,
                topLevelIndex: null,
                groupChildVisualIndex,
                groupId: group.id,
            })
        })
    })

    return rows
}
